import { Component, OnInit } from '@angular/core';
import { SharedDataService, ExtUsersService } from 'ngx-paf-common';

@Component({
  selector: 'folder-sent-to-validation',
  templateUrl: './folder-sent-to-validation.component.html',
  styleUrls: ['./folder-sent-to-validation.component.scss']
})
export class FolderSentToValidationComponent implements OnInit {

  loggedUserId: string;
  supplierIdIfUnique:  number = 0;
  constructor(
    public sharedDataSvc: SharedDataService,
    private extUsersSvc:ExtUsersService) { 
  }



  ngOnInit(): void {
    this.sharedDataSvc.loggedExtUserChange.subscribe(res=>{
      this.loggedUserId=res.Email;
      this.extUsersSvc.getSuppliers(res.Id).subscribe(suppliers=>{
        if (suppliers.length==1){
          this.supplierIdIfUnique = suppliers[0].Id;
        } else {
          this.supplierIdIfUnique = 0;
        }
      })
    });
  }
}
